import { paths } from 'src/compass/site/routes/paths';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';

// Starting or stopping reloads the app at Home, so the menus, permissions and every cached query
// are fetched again as the new user.
const reloadAtHome = (response: any) => {
  onSuccessEnqueueSnackbar(response);
  window.location.href = paths.home;
};

/** Admins and Support users; the backend checks which users each may pick. */
export function useImpersonate() {
  const { mutate, isPending } = useUpdateMutation({
    url: 'Login/Impersonate',
    onSuccess: reloadAtHome,
  });

  return { impersonate: (userId: number) => mutate({ userId }), isPending };
}

export function useStopImpersonating() {
  const { mutate, isPending } = useUpdateMutation({
    url: 'Login/StopImpersonate',
    onSuccess: reloadAtHome,
  });

  return { stopImpersonating: () => mutate(), isPending };
}
